import { FC } from 'react'
import { Typography } from 'antd'
const { Text } = Typography

interface TitleStopProps {
  text: string
  style?: React.CSSProperties
}

const TitleStop: FC<TitleStopProps> = ({ text, style }) => {
  return <Text style={{ ...style, fontWeight: 700 }}>{text}</Text>
}

export default TitleStop
